<template>
  <div class="alert alert-danger">
    This is a page for all world <br />



    {{isSignedIn}}
    <!--    <router-link to="/login">Login</router-link>-->
    {{userInfo}}
    <router-link to="/">
      <br >Home</router-link>
  </div>

</template>

<script>

  import auth from '../app/auth';

export default {
  name: 'HelloWorldEverybody',
  data: function() {
    return{
      userInfo: auth.auth.getCurrentUser(),
      isSignedIn: auth.auth.isUserSignedIn()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
